import "./src/styles/global.css"

// Polyfill for Promise.withResolvers() - required for Safari < 17.4
// react-pdf uses this feature which is not available in older Safari versions
if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
